import React from 'react'
import classNames from 'classnames'
import { renderCell } from '../utils'
import './GridListTd.scss'

const GridListTd = ({ def = {}, sortedBy, item, color, gridView, isCompact, isNarrow, disableMobile, rowBlank, disabledClick, isBordered }) => {
  const { type, column, mobile } = def
  const isSortedBy = sortedBy === column

  return (
    <td
      className={classNames(
        'viso-grid-list-td',
        `viso-grid-list-td--${gridView}`,
        type && `viso-grid-list-td--${type} viso-grid-list-td--${type}--${gridView}`,
        isSortedBy && gridView !== 'card' && 'viso-grid-list-td--sortedBy',
        isCompact && 'viso-grid-list-td--compact',
        isNarrow && 'viso-grid-list-td--narrow',
        mobile && `viso-grid-list-td--mobile-${mobile} viso-grid-list-td--mobile-${mobile}--${gridView}`,
        !disableMobile && 'viso-grid-list-td--mobile-enabled',
        !disableMobile && type && `viso-grid-list-td--${type}--mobile-enabled`,
        !disableMobile && mobile && `viso-grid-list-td--mobile-${mobile}--mobile-enabled`,
        rowBlank && 'viso-text-border',
        disableMobile && rowBlank && 'viso-grid-list-td--mobile-title--card',
        disabledClick && 'viso-grid-list-td--disabled-click',
        isBordered && 'viso-grid-list-td--bordered'
      )}>
      {rowBlank ? rowBlank : renderCell(item, def, color, gridView)}
    </td>
  )
}

export default GridListTd